var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF870F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_30067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 21.4163C7.6665 21.9026 7.85966 22.3689 8.20347 22.7127C8.54729 23.0565 9.01361 23.2497 9.49984 23.2497C9.98607 23.2497 10.4524 23.0565 10.7962 22.7127C11.14 22.3689 11.3332 21.9026 11.3332 21.4163C11.3332 20.9301 11.14 20.4638 10.7962 20.12C10.4524 19.7762 9.98607 19.583 9.49984 19.583C9.01361 19.583 8.54729 19.7762 8.20347 20.12C7.85966 20.4638 7.6665 20.9301 7.6665 21.4163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 21.4163C17.75 21.9026 17.9432 22.3689 18.287 22.7127C18.6308 23.0565 19.0971 23.2497 19.5833 23.2497C20.0696 23.2497 20.5359 23.0565 20.8797 22.7127C21.2235 22.3689 21.4167 21.9026 21.4167 21.4163C21.4167 20.9301 21.2235 20.4638 20.8797 20.12C20.5359 19.7762 20.0696 19.583 19.5833 19.583C19.0971 19.583 18.6308 19.7762 18.287 20.12C17.9432 20.4638 17.75 20.9301 17.75 21.4163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5832 19.5833H9.49984V6.75H7.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50117 8.58301L15.0012 8.97626M21.5443 15.0015L21.4132 15.9182H9.49658",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 9.5H23.25M20.5 6.75V12.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_30067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseCartIcon);
export default __webpack_public_path__ + "static/media/PurchaseCartIcon.33ae510a46e800c60d259bf32e73abd3.svg";
export { ForwardRef as ReactComponent };